<template>
  <div id="energy">
    <div class="title" :class="$mq">
      <h1 v-if="!isTestAchat">{{ $t(`subtitles.estimation.title`) }}</h1>
      <h1 v-else>{{ $t(`branding.TA.energy.subtitles.estimation.title`) }}</h1>
      <h2 v-if="!isTestAchat">{{ $t(`subtitles.estimation.text`) }}</h2>
      <h2 v-else>{{ $t(`branding.TA.energy.subtitles.estimation.text`) }}</h2>
    </div>
    <div class="form" :class="[$mq, {TA:isTestAchat}]">
      <h1>{{ $t("step1.title") }}</h1>

      <div class="section" :class="$mq">
        <div class="title">{{ $t("step1.energy.title") }}</div>
        <div class="container inline bottom">
          <EnergyButton :type="'elec'" :active="type === 'elec'" :title="$t('elec')" @click="type = 'elec'" />
          <EnergyButton :type="'dual'" :active="type === 'both'" :title="$t('dual')" @click="type = 'both'" />
          <EnergyButton :type="'gas'" :active="type === 'gas'" :title="$t('gas')" @click="type = 'gas'" />
        </div>
      </div>
    </div>
    <div class="buttons inline right" :class="$mq">
      <NextButton @click="nextStep()" />
      <!-- <button class="button main" @click="nextStep()">{{ $t("next") }}</button> -->
    </div>
    <div v-if="isTestAchat">
      <p class="lien TA" v-html="$t('branding.TA.energy.disclaimer')"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EnergyButton from "@/components/Energy/EnergyButton.vue";
import NextButton from "../components/NextButton.vue";

export default {
  computed: {
    ...mapGetters("podium", ["isForcedProduct"]),
    ...mapGetters("common", ["isTestAchat"]),
    type: {
      get() {
        return this.$store.state.energy.type;
      },
      set(value) {
        this.$store.commit("comparison/reset");
        this.$store.commit("consumption/setValid", false);
        this.$store.commit("energy/setType", value);
      },
    },
  },
  methods: {
    nextStep: async function () {
      this.$store.commit("energy/setValid", true);
      this.$store.dispatch("common/save");
      this.$store.dispatch("energy/save");
      this.$router.push({ name: "Calculation", query: this.$route.query });
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.$store.dispatch("common/setUuid");

    if(this.isForcedProduct) {
      this.nextStep();
    }
  },
  components: {
    EnergyButton,
    NextButton
  }
};
</script>

<style lang="scss" scoped>
  .TA {
    .lien {
      /deep/ a {
        color: $pink;
        text-decoration: underline $pink!important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Energy.vue